import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AbsiCreate, AbsiDelete, AbsiRefresh, AbsiRefreshByID, AbsiUpdate } from './absi.action';
import { AbsiResource } from '../../absi';
import { AbsiService } from '../../absi.service';

export class AbsiStateModel {
  data: AbsiResource[] = [];
}

@State<AbsiStateModel>({
  name: 'Absi',
  defaults: {
    data: []
  }
})

@Injectable()
export class AbsiState extends BaseState {
  constructor(
    protected override injector: Injector,
    private service: AbsiService,

  ) {
    super(injector);
  }

  @Selector()
  static read(state: AbsiStateModel) {
    return state.data;
  }

  @Action(AbsiRefresh)
  refresh({ patchState }: StateContext<AbsiStateModel>) {
    this.service.getAll().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(AbsiRefreshByID)
  refreshByID({ getState, patchState }: StateContext<AbsiStateModel>, { id }: AbsiRefreshByID) {
    this.service.getById(id).subscribe(item => {
      const state = getState();
      const index = state.data.map(x => x.id).indexOf(id);

      if (index >= 0) {
        state.data.splice(index, 1);
      }
      patchState({
        data: [...state.data, item]
      });
    },
      error => console.error(error)
    );
  }

  @Action(AbsiCreate)
  create({ getState, patchState }: StateContext<AbsiStateModel>, { item }: AbsiCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(AbsiUpdate)
  update({ getState, patchState }: StateContext<AbsiStateModel>, { id, item }: AbsiUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
    }

    patchState({
      data: [...state.data, item]
    });
  }

  @Action(AbsiDelete)
  delete({ getState, patchState }: StateContext<AbsiStateModel>, { id }: AbsiDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }

}
